import { createContext, useContext, useState } from 'react';

interface SheetContext {
  isSheetOpen: boolean
  setIsSheetOpen: (isOpen: boolean) => void
}

const SheetContext = createContext<SheetContext | undefined>(undefined)

const SheetContextProvider = SheetContext.Provider

export const useSheet = () => {
  const context = useContext(SheetContext)

  if (context === undefined) {
    throw new Error('useSheet must be used within a SheetProvider')
  }

  return context
}

export const SheetProvider = ({ children }) => {
  const [isSheetOpen, setIsSheetOpen] = useState<boolean>(false)

  return (
    <SheetContextProvider
      value={{
        isSheetOpen,
        setIsSheetOpen,
      }}
    >
      {children}
    </SheetContextProvider>
  )
}

SheetProvider.displayName = 'SheetProvider'
